module.exports = __webpack_public_path__ + "img/pngegg.e1aeee74.png";